import React from 'react';
import PropTypes from 'prop-types';
import ApplicationsTable from './ApplicationsTable';
import ApplicationsChart from './ApplicationsChart';
import reactWrapper from "@harbor/elements/utils/react/wrapper";
import useI18n from '../../../../../../../i18n/useI18n';

const Applications = (props) => {
    const { tViews } = useI18n('views');
    const [ HbrBadge ] = reactWrapper(["hbr-badge"]);

    return (
        <div
            role="region"
            aria-label={tViews('usageBasedAD.appUsgChartHeader')}
        >
            <h2>{tViews('usageBasedAD.appUsgChartHeader')}{tViews('postSpace')}
                <HbrBadge slot="suffix" pill size="small" aria-hidden="true" data-testid="usage-based-application-circuit-badge">
					{`${tViews('usageBasedAD.Circuit')}: ${props.cuiProps.displayCircuitName}`}
                </HbrBadge>
            </h2>
            <ApplicationsChart
                circuit_name={props.cuiProps.circuitName}
                appList={props.appUsageList}
                setPrevAppUsgList={props.setPrevAppUsgList}
                prevAppUsageList={props.prevAppUsageList}
                selectedHour={props.selectedHour}
            />
            <ApplicationsTable
                circuit_name={props.cuiProps.circuitName}
                setAppUsgList={props.setAppUsgList}
                selectedHour={props.selectedHour}
            />
        </div>
    )
}

Applications.propTypes = {
    cuiProps: PropTypes.object.isRequired,
    setAppUsgList: PropTypes.func,
    appUsageList: PropTypes.array,
    selectedHour: PropTypes.string,
    setPrevAppUsgList: PropTypes.func,
    prevAppUsageList: PropTypes.array
};

export default Applications;
